import { useECMAScriptNext } from './use-ecmascript-next';
import UglifyJS from './uglify-js-browser';
import babelTransform from './babelTransform';

async function babelValidate(code) {
  try {
    await babelTransform(code);
  } catch (e) {
    return {
      isValid: false,
      error: `${e}`
    };
  }

  return { isValid: true };
}

async function uglifyValidate(code) {
  const { error: resultError } = UglifyJS.minify(code);

  if (resultError) {
    return babelValidate(code);
  }

  return {
    isValid: true,
    error: null
  };
}

export default function validate(code) {
  if (code === '') {
    return {
      isValid: false,
      error: 'Empty string is not valid code'
    };
  }

  return useECMAScriptNext ? babelValidate(code) : uglifyValidate(code);
}
